import axios from 'axios';
import ApiClient from './ApiClient';

class CallingAPI extends ApiClient {
  // Bootstraps the Exotel browser softphone: a short-lived access token and
  // the agent's Exotel user id, minted server-side so the app secret never
  // reaches the browser.
  //
  // Goes through the dashboard's global axios instance (window.axios), which
  // carries the session auth headers. The bare `axios` import used by
  // startCall below sends no credentials — that method compensates with an
  // explicit api_access_token header.
  // Creates the account's Exotel VoIP app on first enable (idempotent).
  // eslint-disable-next-line class-methods-use-this
  provisionWebrtc({ accountId }) {
    return window.axios.post(
      `/api/v1/accounts/${accountId}/call/webrtc_provision`
    );
  }

  // eslint-disable-next-line class-methods-use-this
  getWebrtcSession({ accountId }) {
    return window.axios.get(
      `/api/v1/accounts/${accountId}/call/webrtc_session`
    );
  }

  // eslint-disable-next-line class-methods-use-this
  startCall({ to, from, accountId, contactId, accessToken }) {
    const url = `/api/v1/accounts/${accountId}/call`;
    return axios.post(
      url,
      {
        to,
        from,
        contactId,
        baseUrl: window.location.origin,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          api_access_token: accessToken,
        },
      }
    );
  }
}

export default new CallingAPI();
